import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Modal,message } from 'antd';
import './deptProgRelation.css';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Base } from '../../public/js/base';

let DeptProgRelation = (props, ref) => {

    const [content, setContent] = useState("");
    const [isShow, setIsShow] = useState(false);
    useImperativeHandle(ref, () => {
        return {
            setContent,
            setIsShow,
        }
    });

    const [deptProgRelationList, setDeptProgRelationList] = useState([])

    useEffect(() => {
        searchDeptProgRelation()
    }, []);

    const searchDeptProgRelation = () => {
        Base.callBackApi("commonDropDown/searchDeptProgRelation").then((data) => {
            if ("SUCCESS" === data.msg) {
                setDeptProgRelationList(data.object ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    return (
        <Modal
            open={isShow}
            onCancel={() => setIsShow(false)}
            closeIcon={<CloseCircleOutlined style={{color: '#D71920'}} />}
            footer={null}
            className='deptProgRelation'
            width={1000}
            centered
            closable={true}
        >
            <div style={{textAlign: 'justify',hyphens:'none',wordBreak:'break-word'}}>
            Select the relevant THEi programme for this job posting. This will ensure that the posting is accessible to all students enrolled in the specified programme for work-integrated learning internship employment. 
            <br></br><br></br>
            If the job is applicable to multiple programmes, please create additional job postings for each relevant THEi programme. 
            </div>
            
            {deptProgRelationList.map(item => 
                <div key={item.deptId} className='deptBox'>
                    <div className='label'>{item.deptDisplayName}</div>
                    <ul>
                        {item.programmeModelList.map(model => 
                            <li key={model.progId}>{model.progTitle}</li>    
                        )}
                    </ul>
                </div>
            )}
        </Modal>
    )

}

DeptProgRelation = forwardRef(DeptProgRelation);

// DeptProgRelation.propTypes = {
//     done: PropTypes.func.isRequired,
// };

export default DeptProgRelation;